export interface SearchInputForm {
  searchTerm: string;
}
